import React from "react";
import InTransit from "./InTransit";

const ShippingPending = (props) => <InTransit color="#FFA500" {...props} />;

export default ShippingPending;
